import { render, staticRenderFns } from "./a-button-switcher.vue?vue&type=template&id=e44d73fc&"
import script from "./a-button-switcher.vue?vue&type=script&lang=js&"
export * from "./a-button-switcher.vue?vue&type=script&lang=js&"
import style0 from "./a-button-switcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports